import { PageHero, Prose, Clause } from "@/components/site/PageParts";
import { CONTACT } from "@/lib/site";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHero
        index="H/"
        overline="Terms of Use"
        titleLines={["The terms", <>you <span className="italic text-oxblood">agree</span> to</>]}
        intro="The rules governing your use of Doublelist. Please read them carefully."
      />
      <Prose>
        <p className="text-ink-soft text-lg leading-relaxed">
          These Terms of Use govern your access to and use of Doublelist, operated
          by Interlaced Social LLC. By entering or using the platform, you agree to
          these Terms. If you do not agree, do not use the platform. Last updated June 2026.
        </p>

        <Clause number="1" title="You must be 18 or older">
          <p>
            Doublelist is strictly for adults aged 18 and over. By using the
            platform, you represent and warrant that you are at least 18 years old.
            Any use by minors is prohibited and will be terminated.
          </p>
        </Clause>

        <Clause number="2" title="Prohibited conduct">
          <p>You agree not to use Doublelist to post, request, or engage in:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Any illegal content or activity;</li>
            <li>Paid sexual services or solicitation of them;</li>
            <li>Human trafficking, exploitation, or non-consensual content;</li>
            <li>Any content involving or targeting minors;</li>
            <li>Harassment, threats, stalking, or intimidation;</li>
            <li>Impersonation, fraud, spam, or scams;</li>
            <li>Sharing another person's private information without consent.</li>
          </ul>
        </Clause>

        <Clause number="3" title="Consent & respect">
          <p>
            All interactions must be between consenting adults. You are responsible
            for your conduct and for obtaining clear, ongoing consent in any
            interaction that arises through the platform.
          </p>
        </Clause>

        <Clause number="4" title="Enforcement">
          <p>
            We may remove content and suspend or terminate accounts that violate
            these Terms or our Community Rules, at our discretion and without
            notice. We cooperate with lawful investigations where appropriate.
          </p>
        </Clause>

        <Clause number="5" title="No warranties & limitation of liability">
          <p>
            The platform is provided "as is" without warranties of any kind. To the
            fullest extent permitted by law, Interlaced Social LLC is not liable for
            interactions between users or for any damages arising from your use of
            the platform.
          </p>
        </Clause>

        <Clause number="6" title="Changes to these Terms">
          <p>
            We may update these Terms from time to time. Continued use of the
            platform after changes take effect constitutes acceptance of the
            revised Terms.
          </p>
        </Clause>

        <Clause number="7" title="Contact">
          <p>
            Interlaced Social LLC · {CONTACT.address} · {CONTACT.phone} ·{" "}
            <a href={`mailto:${CONTACT.email}`} className="text-oxblood underline">{CONTACT.email}</a>
          </p>
        </Clause>
      </Prose>
    </div>
  );
}
